import { usePage } from "@inertiajs/react";
import Text from "hardcover-ui/components/Text";
import pluralize from "lib/pluralize";

export default function LetterbooksFilterWarning() {
  const {
     filteredBooksCount, totalBookCount
  } = usePage().props;

  if (filteredBooksCount === totalBookCount) {
    return false;
  }
  return (
    <Text variant="secondary" as="p" className="my-2" size="sm">
      Showing {filteredBooksCount.toLocaleString()} of{" "}
      {totalBookCount.toLocaleString()} {pluralize("book", totalBookCount)}{" "}
      based on your filters.
    </Text>
  );
}
